import { ComboboxStore } from '@mantine/core';
import { debounce, uniqBy } from 'es-toolkit';

import { AutoCompleteResult } from '@/models/AddressComplete.ts';

export const MINIMUM_SEARCH_LENGTH = 3;
const DEBOUNCE_MS = 400;

export const buildDisplayName = (result: AutoCompleteResult): string => {
    return `${result.address.road ?? result.address.name} ${result.address.house_number ?? ''}, ${result.address.postcode} ${result.address.city}`;
};

export const buildResults = (results: AutoCompleteResult[]): AutoCompleteResult[] => {
    const has_full_address = results.some((result: AutoCompleteResult) => result.address.house_number);

    let final_results: AutoCompleteResult[] = results;
    if (has_full_address) {
        final_results = results.filter((result: AutoCompleteResult) => result.address.house_number);
    }

    final_results = filterIncompleteResults(final_results);
    final_results = filterDuplicates(final_results);

    return final_results;
};

export const filterIncompleteResults = (results: AutoCompleteResult[]): AutoCompleteResult[] => {
    const filtered_results: AutoCompleteResult[] = results.filter(
        (result: AutoCompleteResult) => result.address.postcode && result.address.city && result.address.house_number
    );
    return filtered_results;
};

export const filterDuplicates = (results: AutoCompleteResult[]): AutoCompleteResult[] => {
    const filtered_results: AutoCompleteResult[] = uniqBy(
        results,
        (item: AutoCompleteResult) =>
            `${item.address.road}${item.address.name}${item.address.house_number}${item.address.postcode}${item.address.city}`
    );
    return filtered_results;
};

export const handleSearch = debounce(
    (search_value: string, setQuery: (value: string) => void, combobox: ComboboxStore) => {
        setQuery(search_value);
        if (search_value.length >= MINIMUM_SEARCH_LENGTH) {
            combobox.openDropdown();
        } else {
            combobox.closeDropdown();
        }
    },
    DEBOUNCE_MS
);
